import toPairs from 'lodash/toPairs'
import * as vuex from 'vuex'

export function mapActions(mutations) {
    const mapping = pairs(mutations).reduce((mapping, { alias, referent }) => {
        mapping[alias] = function(dispatch, payload) {
            return dispatch(this.namespace + '/' + referent, payload);
        };

        return mapping;
    }, {});

    return vuex.mapActions(mapping)
}

export function mapGetters(getters) {
    const mapping = pairs(getters).reduce((mapping, { alias, referent }) => {
        mapping[alias] = function(state, getters) {
            return getters[this.namespace + '/' + referent];
        };

        return mapping;
    }, {});

    return vuex.mapState(mapping)
}

export function mapState(states) {
    const mapping = pairs(states).reduce((mapping, { alias, referent }) => {
        mapping[alias] = function(state) {
            return state[this.namespace][referent];
        };

        return mapping;
    }, {});

    return vuex.mapState(mapping)
}

function pairs(items) {
    const pairs = Array.isArray(items)
        ? items.map(item => [ item, item ])
        : toPairs(items)

    return pairs.map(([ alias, referent ]) => ({ alias, referent }))
}